import theme from '@phonectas/unifon-ui-kit/dist/theme/theme';

// Absolute paths — used in navigate(), <Link to=...>, <Navigate to=...>
export const PATHS = {
	BMO:               '/BMO/cases',
	BMO_CASES:         '/BMO/cases',
	BMO_CASE:          (id: number | string) => `/BMO/cases/${id}`,
	BMO_CREATE_TICKET: '/BMO/create_ticket',
	PROFILE:           '/profile',
	THREE_SIXTY:       '/Unifon360',
	THREE_SIXTY_CUSTOMER: (id: number | string) => `/Unifon360/${id}`,
	THREE_SIXTY_NUMBER:   (numb: string) => `/Unifon360/n/${numb}`,
	MRC:               '/mrc',
	UNAUTHORIZED:      '/unauthorized',
};

// Route patterns — used only in <Route path=...>
export const ROUTE_PATTERNS = {
	BMO:               '/BMO/*',
	BMO_CASES:         'cases',
	BMO_CASE:          'cases/:id',
	BMO_CREATE_TICKET: 'create_ticket',
	PROFILE:           '/profile',
	THREE_SIXTY:       '/Unifon360',
	THREE_SIXTY_CUSTOMER: '/Unifon360/:id',
	THREE_SIXTY_NUMBER:   '/Unifon360/n/:numb',
	MRC:               '/mrc',
	UNAUTHORIZED:      '/unauthorized',
};

export const ROUTES = {
	PROFILE: '/profile',
	DASHBOARD: '/dashboard',
	BMODASHBOARD: '/BMO/cases', 
	BMO_ROUTE: '/BMO/*',
	BMO_DEFAULT: '/BMO/cases',
	BMO_DASHBOARD: 'cases',
	BMO_CREATE_TICKET: 'create_ticket',
	BMO_CASES: 'cases',
	BMO_CASES_ID: 'cases/:id',
	THREE_SIXTY: '/Unifon360',
	THREE_SIXTY_CUSTOMER: '/Unifon360/:id',
	THREE_SIXTY_NUMBER_NUMB: '/Unifon360/n/:numb',
	UNAUTHORIZED_USER: '/unauthorized',
	MRC: '/mrc',
};

export const RESPONSE_STATUSES = {
	OK: 'OK',
	ERROR: 'error',
};
export const DEBOUNCE_INPUT_TIMEOUT = 400;

export const SORT_DIR = {
	ASC: 'asc',
	DESC: 'desc',
};

export const SORT_SUBSCRIPTION_BY = {
	NAME: 'FirstName',
	PHONE: 'PhoneNumber',
	PROFILE: 'ProfileName',
	SUM_USAGE_WORK: 'SumUsageWork',
	SUM_USAGE_PRIVATE: 'SumUsagePrivate',
	SUM_USAGE_TOTAL: 'SumUsageTotal',
	DATA_SIZE: 'DataSize',
	DATA_FREE: 'DataFree',
};

export const CUSTOM_COLOR_INFO = '#1488F2';

// roles
export const ROLES = {
	ADMIN: 'admin',
	BMO: 'bmo',
	LARGEACC: 'largeaccount',
	CUSTOMER_SERVICE: 'customerservice',
	MRC: 'mrc',
	KS_USER: 'ksuser',
	KS_ADMIN: 'ksadmin'
};

export const THREE_SIXTY_ROLES = {
	BMO: 'bmo',
	LARGEACC: 'largeaccount',
	CUSTOMER_SERVICE: 'customerservice',
	MRC: 'mrc',
	ADMIN: 'admin',
};

export const LIMIT_PAYLOAD = 50;

export const USERS_DEFAULT_FILTERS = ['100', '200', '310'];
export const USERS_NO_FILTERS = ['100', '200', '220', '230', '240', '280', '310', '400', '410'];

export const THEME_PALETTE = theme.palette;
export const SALES_CRM_URL = 'https://selger.unifon.no/onboarding/';
export const isProduction = process.env['NODE_ENV'] === 'production';
export const isDevMode = process.env['NODE_ENV'] === 'development';